var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.17 17.6953C47.9317 18.062 48.6294 18.6247 49.1778 19.3717C49.7261 20.1186 50.0799 21.0116 50.1897 21.8785",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1791 15.5369C49.2826 16.0681 50.2935 16.8834 51.088 17.9657C51.8824 19.0479 52.395 20.3416 52.5541 21.5976",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3091 27.3721C15.4543 26.5821 15.7952 25.8014 16.3424 25.1116C16.8897 24.4217 17.6195 23.8737 18.3866 23.5557",
    stroke: "white",
    strokeWidth: 0.673044,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0082 27.1004C13.2186 25.9558 13.7125 24.8248 14.5053 23.8253C15.2982 22.8259 16.3555 22.0318 17.4669 21.5711",
    stroke: "white",
    strokeWidth: 0.673044,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6185 34.9919C33.6185 34.9919 32.8261 33.1558 32.4853 32.5295C32.1445 31.9033 31.3777 30.9021 30.8792 30.4378C30.3808 29.9734 29.1155 29.1427 27.9951 30.1949C26.8747 31.2472 28.5148 32.2909 28.5148 32.2909C28.5148 32.2909 29.6779 33.0322 29.7759 35.469C29.9037 38.6386 31.1263 39.9678 32.9454 41.2373C34.7645 42.5069 34.8923 44.4964 34.8923 44.4964",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6758 23.9793C42.6758 23.9793 42.7013 22.1006 44.5034 22.1006C46.1691 22.1006 46.2884 24.0432 46.2884 24.0432C46.2884 24.0432 46.3992 31.0768 46.2756 33.2751C46.1521 35.4733 45.9817 38.3916 45.0359 41.3396C44.6397 42.5751 44.5758 44.4964 44.5758 44.4964",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7965 33.1555C32.7965 33.1555 32.1958 21.5124 32.1617 20.6647C32.1276 19.8169 32.1063 18.5814 33.6272 18.4366C35.2035 18.3982 35.4122 19.4079 35.4676 20.2514C35.523 21.0949 35.9788 31.2214 35.9788 31.2214L35.4037 18.9137C35.4037 18.9137 35.3313 17.0137 37.095 17.0137C38.4966 17.0137 38.7906 17.9467 38.8289 18.8413C38.8502 19.3696 39.272 31.0766 39.272 31.0766L38.9056 20.6093C38.9056 20.6093 38.6798 18.2875 40.6608 18.2875C42.3606 18.2875 42.5992 19.6806 42.629 20.4815C42.6588 21.2824 42.7398 31.3535 42.7398 31.3535",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8918 29.0961C24.8918 29.0961 26.042 27.4602 26.3999 26.8425C26.7577 26.2247 27.2093 25.0489 27.3414 24.3801C27.4734 23.7112 27.5246 22.2031 26.042 21.7899C24.5595 21.3766 24.5254 23.3278 24.5254 23.3278C24.5254 23.3278 24.4998 24.7081 22.4762 26.0629C19.8434 27.8266 19.345 29.5647 19.2129 31.78C19.0809 33.9953 17.4492 35.1456 17.4492 35.1456",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3926 39.8232C29.7098 40.6838 27.6948 41.5997 25.4411 42.1493C24.1844 42.456 22.5059 43.4061 22.5059 43.4061",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0293 27.4342C26.0293 27.4342 29.3906 25.1294 32.2833 23.1484",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clap.9534d76f873d26c1d3016927d25d3442.svg";